import { DiagramSnapshot } from 'src/containers/ProjectDiagram/types/diagram';
import {
  isModelConceptClass,
  isModelConceptRelationship,
} from 'src/containers/ProjectDiagram/utils/data';

// also see hasModelConcepts selector
export const hasModelConcepts = (diagram: DiagramSnapshot) => {
  const { model } = diagram;

  // hierarchies will not exist without classes
  const hasClasses = model.nodeDataArray.some(isModelConceptClass);
  const hasRelationships = model.linkDataArray.some(isModelConceptRelationship);
  const hasAttributes =
    Object.values(model.modelData.attributesByIri).length > 0;
  // attributes will probably only exist without classes if imported from Stardog, so make this check last
  return hasClasses || hasRelationships || hasAttributes;
};
